import { Outlet } from 'react-router-dom';
import React from 'react';
import Guard from '@/components/appShell/Guard';
import GenericTemplate from '@/components/appShell/GenericTemplate';

const AppShell: React.FC = () => (
  <Guard>
    <GenericTemplate>
      <Outlet />
    </GenericTemplate>
  </Guard>
);

export default AppShell;
